import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import React, {useCallback, useContext, useMemo, useState} from 'react';
import parse from 'html-react-parser';

export default function SeoFooter({seoFooter}) {
    const {texts} = useContext(articleOverviewStaticContext);
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = useCallback(() => {
        setShowAll(prevShowAll => !prevShowAll);
    },[]);

    const parsedIntroduction = useMemo(() => parse(seoFooter.introductionAsString), [seoFooter.introductionAsString]);
    const parsedEntries = useMemo(() => parse(seoFooter.entriesAsString), [seoFooter.entriesAsString]);
    const toggleText = showAll ? texts.category_info_show_less : texts.category_info_show_more;

    return (
        <>
            <div className={`info__content-text${showAll ? " -show-all" : ""}`}>
                {parsedIntroduction}
                {showAll && parsedEntries}
            </div>
            <button className="info__content-trigger" onClick={toggleShowAll}>{toggleText}</button>
        </>
    );
}
